module.exports = __webpack_public_path__ + "img/reset-success-img.1ac94667.svg";